import { Box } from '@mui/material';
import WalletExchangeDemo from './demos/WalletExchangeDemo';
import HowItWorksDemo from './demos/HowItWorksDemo';
import CreditCardEntryDemo from './demos/CreditCardEntryDemo';
import HashatarApplicationsDemo from './demos/HashatarApplicationsDemo';
import DemoSection from './demos/DemoSection';

/**
 * Copy-paste demo section component with three distinct sections
 */
export default function CopyPasteDemo() {
  return (
    <Box>
      {/* Section 1: Wallet Exchange Demo */}
      <DemoSection backgroundColor="#e3f2fd">
        <WalletExchangeDemo />
      </DemoSection>

      {/* Section 2: How It Works Demo */}
      <DemoSection backgroundColor="#f8f9fa">
        <HowItWorksDemo />
      </DemoSection>

      {/* Section 3: Credit Card Entry Demo */}
      <DemoSection backgroundColor="#fff3e0">
        <CreditCardEntryDemo />
      </DemoSection>

      {/* Section 4: Hashatar Applications Demo */}
      <DemoSection backgroundColor="#f3e5f5">
        <HashatarApplicationsDemo />
      </DemoSection>
    </Box>
  );
}
